export default __webpack_public_path__ + "static/media/avatar.3ead7426.svg";